export default "__VITE_ASSET__a1146879__"